import type { DateTime } from 'luxon'

import type { WorldLevel } from '@/queries/constants'

export enum Priority {
  Chill = 4,
  Low = 3,
  Medium = 2,
  High = 1,
  Urgent = 0,
}

export type TodoItem = {
  worldSlug?: string | null
  title: string
  subtitle?: string
  emoji: string
  tag?: {
    title: string
  }
  stepsRemaining?: number
  completed: boolean
  link?: string
  onClick?: () => void
  deadline?: DateTime | null
  priority: Priority
  // We only support filtering TODOs in the learn or tutor view in programs subworlds so that tutor todos aren't visibile in the learn view and vice versa.
  targetLevel?: Extract<WorldLevel, 'member' | 'tutor'>
  disabled?: {
    tooltip: string
  } | null
  openLinkInNewTab?: boolean
  additionalComponent?: () => JSX.Element
  showOnSeriesPage?: boolean // Defaults to false. Todos have to opt-in to show on the series page.
}
